module.exports = __webpack_public_path__ + "static/media/john.3fb6518f.jpg";